import type { Layout } from '@/GameUI/Definitions';
import { MINI_SCORE_HEIGHT } from '@/GameUI/Sprites/MiniScore';
import { TIMER_BAR_HEIGHT } from '@/GameUI/Sprites/TimerBar';
import { HALF_SCREEN_HEIGHT, HALF_SCREEN_WIDTH, MAX_HEIGHT, MAX_WIDTH } from '@/utilities/Screen';

const CARD_OFFSET = 45;

const CARD_HEIGHT = 250;
const CARD_HEIGHT_HALF = CARD_HEIGHT / 2;
const CARD_WIDTH = 180;
const CARD_WIDTH_HALF = CARD_WIDTH / 2;
const HAND_WIDTH = 600;
const HAND_PADDING = -40;
const HALF_HAND_WIDTH = HAND_WIDTH / 2;
const BOTTOM_PLAYER_HAND_PADDING = 50;
const PLAYED_OFFSET_Y = -90;
const PLAYED_PADDING = 300;

const HALF_MINI_SCORE_HEIGHT = MINI_SCORE_HEIGHT / 2;

export default [
	{
		id: 'handTop',
		type: 'hand',
		x: HALF_SCREEN_WIDTH + HALF_HAND_WIDTH,
		y: HAND_PADDING,
		xCenterOffset: 0,
		top: -20,
		offset: CARD_OFFSET,
		rotation: 180,
		width: CARD_WIDTH,
		height: CARD_HEIGHT,
		pileWidth: HAND_WIDTH - 200,
		cardsVisible: false,
		selectedOffestY: 30,
		arcRadius: 600,
		arcAngle: 25,
		useArc: false,
	},
	{
		id: 'handRight',
		type: 'hand',
		x: MAX_WIDTH - HAND_PADDING,
		y: HALF_SCREEN_HEIGHT + HALF_HAND_WIDTH,
		yCenterOffset: -150,
		right: -20,
		rotation: 270,
		offset: CARD_OFFSET,
		width: CARD_WIDTH,
		height: CARD_HEIGHT,
		pileWidth: HAND_WIDTH - 200,
		cardsVisible: false,
		selectedOffestX: -30,
		arcRadius: 600,
		arcAngle: 25,
		useArc: false,
	},
	{
		id: 'handBottom',
		type: 'localHand',
		x: HALF_SCREEN_WIDTH - HALF_HAND_WIDTH,
		y: MAX_HEIGHT - BOTTOM_PLAYER_HAND_PADDING,
		xCenterOffset: 36,
		bottom: CARD_HEIGHT_HALF + 40,
		offset: CARD_OFFSET,
		rotation: 0,
		width: CARD_WIDTH,
		height: CARD_HEIGHT,
		pileWidth: 800,
		cardsVisible: true,
		selectedOffestY: -30,
		arcRadius: 660,
		arcAngle: 70,
		useArc: true,
	},
	{
		id: 'handLeft',
		type: 'hand',
		x: HAND_PADDING,
		y: HALF_SCREEN_HEIGHT - HALF_HAND_WIDTH,
		yCenterOffset: -150,
		left: -20,
		rotation: 90,
		offset: CARD_OFFSET,
		width: CARD_WIDTH,
		height: CARD_HEIGHT,
		pileWidth: HAND_WIDTH - 200,
		cardsVisible: false,
		selectedOffestX: 30,
		arcRadius: 600,
		arcAngle: 25,
		useArc: false,
	},
	{
		id: 'trickTop',
		x: HALF_SCREEN_WIDTH,
		y: PLAYED_PADDING,
		z: 20,
		xCenterOffset: 0 - CARD_WIDTH_HALF,
		yCenterOffset: -65 + PLAYED_OFFSET_Y,
		rotation: 0,
		offset: 0,
		width: CARD_WIDTH,
		height: CARD_HEIGHT,
		cardsVisible: true,
	},
	{
		id: 'trickRight',
		x: MAX_WIDTH - PLAYED_PADDING,
		y: HALF_SCREEN_HEIGHT,
		z: 40,
		xCenterOffset: 150 - CARD_WIDTH_HALF,
		yCenterOffset: 0 + PLAYED_OFFSET_Y,
		rotation: 0,
		offset: 0,
		width: CARD_WIDTH,
		height: CARD_HEIGHT,
		cardsVisible: true,
	},
	{
		id: 'trickBottom',
		x: HALF_SCREEN_WIDTH,
		y: MAX_HEIGHT - PLAYED_PADDING,
		z: 30,
		xCenterOffset: 0 - CARD_WIDTH_HALF,
		yCenterOffset: 70 + PLAYED_OFFSET_Y,
		rotation: 0,
		offset: 0,
		width: CARD_WIDTH,
		height: CARD_HEIGHT,
		cardsVisible: true,
	},
	{
		id: 'trickLeft',
		x: PLAYED_PADDING,
		y: HALF_SCREEN_HEIGHT,
		z: 10,
		xCenterOffset: -150 - CARD_WIDTH_HALF,
		yCenterOffset: 0 + PLAYED_OFFSET_Y,
		rotation: 0,
		offset: 0,
		width: CARD_WIDTH,
		height: CARD_HEIGHT,
		cardsVisible: true,
	},
	{
		id: 'trickWinningsTop',
		x: 0,
		y: 0,
		z: 10,
		top: -200,
		xCenterOffset: 0,
		yCenterOffset: null,
		cardsVisible: true,
	},
	{
		id: 'trickWinningsRight',
		x: 0,
		y: 0,
		z: 10,
		right: -200,
		xCenterOffset: null,
		yCenterOffset: 0,
		cardsVisible: true,
	},
	{
		id: 'trickWinningsBottom',
		x: 0,
		y: 0,
		z: 10,
		bottom: -200,
		xCenterOffset: 0,
		yCenterOffset: null,
		cardsVisible: true,
	},
	{
		id: 'trickWinningsLeft',
		x: 0,
		y: 0,
		z: 10,
		left: -200,
		xCenterOffset: null,
		yCenterOffset: 0,
		cardsVisible: true,
	},

	{
		id: 'backButton',
		x: 50,
		y: 50,
		z: 10001,
		width: 80,
		height: 80,
	},
	{
		id: 'scoreBoard',
		x: 0,
		y: 0,
		// right: 180,
		z: 100,
	},
	{
		id: 'menuBar',
		x: 0,
		y: 0,
		z: 1000,
	},
	{
		id: 'roundScoreBoard',
		z: 1000,
		xCenterOffset: -250,
		yCenterOffset: -(730 / 2),
	},
	{
		id: 'background',
		x: 0,
		y: 0,
		widthPercent: 100,
		heightPercent: 100,
	},
	{
		id: 'gameOver',
		x: 0,
		y: 0,
		xCenterOffset: -250,
		yCenterOffset: -(730 / 2),
		z: 1000,
	},
	{
		id: 'instructions',
		x: HALF_SCREEN_WIDTH,
		y: 250,
		xCenterOffset: 0,
	},
	{
		id: 'continueButton',
		x: HALF_SCREEN_WIDTH,
		y: 400,
		// width: 420,
		// height: 150,
		xCenterOffset: 0,
	},
	{
		id: 'heartsBrokenIcon',
		x: 75,
		y: 60,
		z: 100,
	},
	{
		id: 'heartsBrokenIconHidden',
		x: -100,
		y: -100,
		z: 100,
	},
	{
		id: 'miniScoreTop',
		top: HALF_MINI_SCORE_HEIGHT,
		xCenterOffset: 0,
		z: 100,
	},
	{
		id: 'miniScoreRight',
		yCenterOffset: -150,
		xCenterOffset: 0,
		right: HALF_MINI_SCORE_HEIGHT,
		rotation: 270,
		z: 100,
	},
	{
		id: 'miniScoreBottom',
		bottom: HALF_MINI_SCORE_HEIGHT,
		xCenterOffset: 0,
		z: 100,
	},
	{
		id: 'miniScoreLeft',
		rotation: 90,
		yCenterOffset: -150,
		xCenterOffset: 0,
		left: HALF_MINI_SCORE_HEIGHT,
		z: 100,
	},
	{
		id: 'timerTop',
		top: MINI_SCORE_HEIGHT + TIMER_BAR_HEIGHT / 2 + 2,
		xCenterOffset: 0,
		z: 100,
	},
	{
		id: 'timerRight',
		yCenterOffset: -150,
		xCenterOffset: 0,
		right: MINI_SCORE_HEIGHT + TIMER_BAR_HEIGHT / 2 + 2,
		rotation: 270,
		z: 100,
	},
	{
		id: 'timerBottom',
		bottom: MINI_SCORE_HEIGHT + TIMER_BAR_HEIGHT / 2 + 2,
		xCenterOffset: 0,
		z: 100,
	},
	{
		id: 'timerLeft',
		rotation: 90,
		yCenterOffset: -150,
		xCenterOffset: 0,
		left: MINI_SCORE_HEIGHT + TIMER_BAR_HEIGHT / 2 + 2,
		z: 100,
	},
] as Layout[];
